// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"9a3d6bb5","453":"0ff69c70"}[chunkId] + ".chunk.js";
};